/**
 * Calculate CSAT (Customer Satisfaction Score) for a rating question.
 *
 * Rules (per John's spec):
 *   - ≤4 distinct values  → top 1 value only
 *   - 5 distinct values   → top 2 values  (e.g. 1-5 or 0-4)
 *   - ≥6 distinct values  → top 3 values  (e.g. 0-5, 1-10, 0-10)
 *
 * min ∈ {0, 1}, max ∈ {2…10} (as configured in the survey editor).
 *
 * Returns a percentage rounded to 1 decimal place, or null when there
 * are no responses.
 */
export function calculateCSAT(results, minValue, maxValue) {
  const totalCount = results?.reduce((acc, curr) => acc + curr.count, 0);
  if (!totalCount) return null;

  const scaleSize = maxValue - minValue + 1;

  let topValues;
  if (scaleSize <= 4) {
    topValues = [maxValue];
  } else if (scaleSize === 5) {
    topValues = [maxValue - 1, maxValue];
  } else {
    topValues = [maxValue - 2, maxValue - 1, maxValue];
  }

  const topCount = results.filter((r) => topValues.includes(+r.value)).reduce((acc, curr) => acc + curr.count, 0);

  return Math.round((topCount / totalCount) * 1000) / 10;
}

export const CSAT_TOOLTIP =
  'CSAT (Customer Satisfaction) is calculated by what percentage of customers choose your top rankings. ' +
  'For a scale of 1-5 we use 4 or 5. For a scale of 1-10 we use 8, 9, or 10. ' +
  'For scales with 4 or less values we use only the top value.';
